<template>
    <h3
        class="block font-bold text-primary"
        :class="{
            'text-base font-semibold text-secondary': theme === Theme.Secondary,
            'text-xs font-medium tracking-wide text-tertiary': theme === Theme.Tertiary,
        }"
        data-spec-class="card_list-title"
    >
        <slot></slot>
    </h3>
</template>

<script setup lang="ts">
import { Theme } from '@/types';
import { defineProps, withDefaults } from 'vue';

interface Props {
    theme?: Theme;
}

withDefaults(defineProps<Props>(), {
    theme: Theme.Normal,
});
</script>
